var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-header" }, [
    _c(
      "a",
      {
        staticClass: "mobile-menu-toggle",
        attrs: { href: "#mobile-menu-01", "data-toggle": "collapse" },
      },
      [_vm._v("\n        Mobiles Menü umschalten\n    ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("nav", { attrs: { id: "main-menu", role: "navigation" } }, [
        _c("ul", { staticClass: "menu" }, [
          _c(
            "li",
            {
              staticClass: "menu-item",
              class: { active: _vm.getPathName("services") },
            },
            [
              _c(
                "a",
                {
                  staticStyle: { color: "white" },
                  attrs: { href: "/services/" },
                },
                [_vm._v(_vm._s(_vm.services[_vm.getCurrentLocale]))]
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "nav",
      { staticClass: "mobile-menu collapse", attrs: { id: "mobile-menu-01" } },
      [
        _c(
          "ul",
          { staticClass: "menu", attrs: { id: "mobile-primary-menu" } },
          [
            _c(
              "li",
              {
                staticClass: "menu-item",
                class: { active: _vm.getPathName("services") },
              },
              [
                _c("a", { attrs: { href: "/services/" } }, [
                  _vm._v(_vm._s(_vm.services[_vm.getCurrentLocale])),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("ul", { staticClass: "mobile-topnav container" }, [
          _c("li", { staticClass: "ribbon language menu-color-skin" }, [
            _c("a", { attrs: { href: "#" } }, [
              _vm._v(
                _vm._s(_vm.language[_vm.getCurrentLocale]) +
                  " (" +
                  _vm._s(_vm.lang) +
                  ")"
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "menu mini" },
              [
                _c("li", { class: { active: _vm.lang === "de" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#", title: "Deutsch" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.changeLanguage("de")
                        },
                      },
                    },
                    [_vm._v("Deutsch")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { class: { active: _vm.lang === "en" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#", title: "English" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.changeLanguage("en")
                        },
                      },
                    },
                    [_vm._v("English")]
                  ),
                ]),
                _vm._v(" "),
                _c("v-dialog"),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "logo navbar-brand" }, [
      _c("a", { attrs: { href: "/index.php" } }, [
        _c("img", {
          attrs: { src: "/res/images/logo.png", alt: "smein-wunschplatz" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }